<template>
    <div>
        <loading-gdb :propObject="StateCursosLoading" text="Carregando Cursos..."></loading-gdb>
        <loading-gdb :propObject="StateDisciplinasLoading || StateDisciplinasGLoading" text="Carregando Disciplinas"></loading-gdb>
        <loading-gdb :propObject="StateTurmasLoading || StateTurmasGLoading" text="Carregando Turmas..."></loading-gdb>
        <loading-gdb :propObject="StateGerenciadasGLoading" text="Carregando dados de Gerenciadas"></loading-gdb>
        <loading-gdb :propObject="StateResetPasswordMoodleUNDBLoading" text="Redefinindo Senha"></loading-gdb>
        <loading-gdb :propObject="StateCoordenadoresLoading || StateCoordenadoresGLoading" text="Carregando Coordenadores..."></loading-gdb>
        <loading-gdb :propObject="StateProfessoresLoading || StateProfessoresGLoading" text="Carregando Professores..."></loading-gdb>
        <loading-gdb :propObject="StateAlunosLoading || StateAlunosGLoading" text="Carregando Alunos..."></loading-gdb>
        <loading-gdb :propObject="StateIntegraLoading" text="Integrando..."></loading-gdb>
        <v-card variant="outlined">
            <v-card-title>Período Letivo</v-card-title>
            <v-card-text>
                <!-- Integra coord -->
                <v-row>
                    <v-spacer></v-spacer>
                    <confirm-gdb @confirm="integrar($event, {
                            coord: '1',
                        })"
                        title="Integrar Coordenações na plataforma UNDB Classroom"
                        header="Integração de Coordenações"
                        :message="`Confirma a integração das <b>COORDENACÕES</b> na plataforma UNDB Classroom?`">
                        <template v-slot:buttonaction>
                            <v-btn :loading="StateIntegraLoading">
                                <v-icon>mdi-cloud-upload</v-icon> &nbsp; Coordenações
                            </v-btn>
                        </template>
                    </confirm-gdb>
                </v-row>
                <!-- Pesquisa Perlet -->
                <v-row class="my-2" >
                    <v-col sm="6" md="4" lg="4" cols="12">
                        <v-text-field autofocus hide-details
                            :loading="StatePerletsLoading"
                            v-model="parametros.codperlet"
                            label="Pesquisar período letivo (UNDB)">
                            <template v-slot:append>
                                <v-btn icon :loading="StatePerletsLoading"
                                    @click="searchPerlets"
                                    :disabled="(parametros.codperlet||'').length < 4">
                                    <v-icon>mdi-magnify</v-icon>
                                </v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                </v-row>
                <!-- Select Perlet -->
                <v-row v-show="StatePerlets.length">
                    <v-col cols="12" sm="10" md="8" lg="6">
                        <v-select
                            :loading="StatePerletsLoading"
                            :disabled="StatePerletsLoading"
                            label="Período letivo"
                            v-model="selectedPerlet"
                            :items="StatePerlets"
                            :item-title="v => `${v.IDPERLET} - ${v.CODPERLET} - ${v.DESCRICAO}`"
                            return-object
                        >
                        </v-select>
                    </v-col>
                </v-row>
                <v-btn @click="tab = 'normais'" :color="tab === 'normais' ? 'secondary': 'primary'">Normais</v-btn>
                <v-btn @click="tab = 'gerenciais'" :color="tab === 'gerenciais' ? 'secondary': 'primary'">Gerenciais</v-btn>
                <v-btn @click="tab = 'gerenciadas'" :color="tab === 'gerenciadas' ? 'secondary': 'primary'">Gerenciadas</v-btn>
                <v-divider class="primary my-2"></v-divider>
                <!-- NORMAIS -->
                <div v-show="tab === 'normais'">
                    <!-- CURSOS -->
                    <v-row v-show="!!selectedPerlet">
                        <v-col cols="12" sm="8" md="6" lg="4">
                            <v-autocomplete
                                no-data-text="Nenhum registro encontrado"
                                :disabled="StateCursosLoading"
                                label="Cursos"
                                v-model="selectedCurso"
                                :items="StateCursos"
                                :item-title="v => `${v.CODCURSO} - ${v.NOME}`"
                                return-object
                                >
                                <template v-slot:append-outer>
                                    <confirm-gdb v-if="!!selectedCurso && false" @confirm="integrar($event, {
                                            codcurso: selectedCurso.CODCURSO,
                                        })"
                                        title="Integrar curso na plataforma UNDB Classroom"
                                        header="Integração de curso"
                                        :message="`Confirma a integração do curso <b>${selectedCurso.CODCURSO} - ${selectedCurso.NOME}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon color="success">
                                                <v-icon >mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <!-- TURMAS -->
                    <v-row v-show="!!selectedCurso">
                        <v-col cols="12" sm="6" md="6" lg="4">
                            <v-autocomplete
                                no-data-text="Nenhum registro encontrado"
                                :disabled="StateTurmasLoading"
                                label="Turmas"
                                v-model="selectedTurma"
                                :items="StateTurmas"
                                item-title="CODTURMA"
                                return-object
                                >
                                <template v-slot:append>
                                    <confirm-gdb v-if="!!selectedTurma" @confirm="integrar($event, {
                                            codturma: selectedTurma.CODTURMA,
                                            codcurso: selectedCurso.CODCURSO,
                                        })"
                                        title="Integrar turma na plataforma UNDB Classroom"
                                        header="Integração de turma"
                                        :message="`Confirma a integração do turma <b>${selectedTurma.CODTURMA}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon>
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <!-- DISCIPLINAS -->
                    <v-row v-show="!!selectedTurma">
                        <v-col cols="12" sm="8" md="6" lg="4">
                            <v-autocomplete
                                no-data-text="Nenhum registro encontrado"
                                :disabled="StateDisciplinasLoading"
                                label="Disciplinas"
                                v-model="selectedDisciplina"
                                :items="StateDisciplinas"
                                :item-title="v => `${v.IDNUMBER} - ${v.CODDISC} - ${v.DISCIPLINA}`"
                                return-object
                                >
                                <template v-slot:append>
                                    <confirm-gdb v-if="!!selectedDisciplina" @confirm="integrar($event, {
                                            codturma: selectedTurma.CODTURMA,
                                            coddisc: selectedDisciplina.CODDISC,
                                            codcurso: selectedCurso.CODCURSO,
                                        })"
                                        title="Integrar disciplina na plataforma UNDB Classroom"
                                        header="Integração de disciplina"
                                        :message="`Confirma a integração da disciplina <b>${selectedDisciplina.CODDISC} - ${selectedDisciplina.DISCIPLINA}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon>
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <!-- COORDENADORES -->
                    <v-row
                        v-show="StateCoordenadores.length && !!selectedCurso">
                        <div>
                            <h4>Coordenadores ({{StateCoordenadores.length}})</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="coord in StateCoordenadores" :key="coord.CODPROF">
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            usuario: coord.CODPROF,
                                            codturma: selectedTurma.CODTURMA,
                                            coddisc: selectedDisciplina.CODDISC,
                                            codcurso: selectedCurso.CODCURSO,
                                        })"
                                        title="Integrar usuário na plataforma UNDB Classroom"
                                        header="Integração de usuário"
                                        :message="`Confirma a integração do usuário <b>${coord.CODPROF} ${coord.NOME}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <confirm-gdb @confirm="onConfirmResetPassword($event, coord.CODPROF)"
                                        title="Redefinição de senha UNDB Classroom"
                                        header="Redefinição de senha"
                                        :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário ${coord.CODPROF} ${coord.NOME} na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon color="warning" size="x-small"
                                                :loading="StateResetPasswordMoodleUNDBLoading"
                                                >
                                                <v-icon>mdi-lock-reset</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{coord.CODPROF}} - {{coord.NOME}} - {{coord.EMAIL}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                    <!-- PROFESSORES -->
                    <v-row v-show="StateProfessores.length && !!selectedDisciplina">
                        <div>
                            <h4>Professores ({{StateProfessores.length}})</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="prof in StateProfessores" :key="prof.CODUSUARIO">
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            usuario: prof.CODUSUARIO,
                                            codturma: selectedTurma.CODTURMA,
                                            coddisc: selectedDisciplina.CODDISC,
                                            codcurso: selectedCurso.CODCURSO,
                                        })"
                                        title="Integrar usuário na plataforma UNDB Classroom"
                                        header="Integração de usuário"
                                        :message="`Confirma a integração do usuário <b>${prof.CODUSUARIO} ${prof.NOME}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <confirm-gdb @confirm="onConfirmResetPassword($event, prof.CODUSUARIO)"
                                        title="Redefinição de senha UNDB Classroom"
                                        header="Redefinição de senha"
                                        :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário ${prof.CODUSUARIO} ${prof.NOME} na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small" color="warning">
                                                <v-icon>mdi-lock-reset</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{prof.CODUSUARIO}} - {{prof.NOME}} - {{prof.EMAIL}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                    <!-- ALUNOS (NORMAIS) -->
                    <v-row v-show="StateAlunos.length && !!selectedDisciplina">
                        <div>
                            <h4>Alunos ({{StateAlunos.length}})</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="alu in StateAlunos" :key="alu.RA">
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            usuario: alu.CODUSUARIO,
                                            codturma: selectedTurma.CODTURMA,
                                            coddisc: selectedDisciplina.CODDISC,
                                            codcurso: selectedCurso.CODCURSO,
                                        })"
                                        title="Integrar usuário na plataforma UNDB Classroom"
                                        header="Integração de usuário"
                                        :message="`Confirma a integração do usuário <b>${alu.RA} ${alu.ALUNO}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <confirm-gdb @confirm="onConfirmResetPassword($event, alu.RA)"
                                        title="Redefinição de senha UNDB Classroom"
                                        header="Redefinição de senha"
                                        :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário ${alu.RA} ${alu.ALUNO} na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small" color="warning">
                                                <v-icon>mdi-lock-reset</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{alu.RA}} - {{alu.ALUNO}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                </div>
                <!-- GERENCIAIS -->
                <div v-show="tab === 'gerenciais'">
                    <!-- TURMAS GERENCIAIS -->
                    <v-row v-show="!!selectedPerlet">
                        <v-col cols="12" sm="8" md="6" lg="4">
                            <v-autocomplete
                                no-data-text="Nenhum registro encontrado"
                                :disabled="StateTurmasGLoading"
                                label="Turmas Gerenciais"
                                v-model="selectedTurmaG"
                                :items="StateTurmasG"
                                :item-title="v => `${v.IDTURMADISC} - ${v.CODTURMA}`"
                                return-object
                                >
                                <template v-slot:append-outer>
                                    <confirm-gdb v-if="!!selectedTurmaG" @confirm="integrar($event, {
                                            codturma: selectedTurmaG.CODTURMA,
                                        })"
                                        title="Integrar turma na plataforma UNDB Classroom"
                                        header="Integração de turma"
                                        :message="`Confirma a integração do turma <b>${selectedTurmaG.CODTURMA}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                </template>
                            </v-autocomplete>
                        </v-col>
                    </v-row>
                    <!-- DISCIPLINAS GERENCIAIS -->
                    <v-row
                        v-show="StateDisciplinasG.length && !!selectedTurmaG">
                        <div>
                            <h4>Disciplinas</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="disc in StateDisciplinasG" :key="disc.CODPROF" >
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            codturma: selectedTurmaG.CODTURMA,
                                            coddisc: disc.CODDISC,
                                        })"
                                        title="Integrar disciplina na plataforma UNDB Classroom"
                                        header="Integração de disciplina"
                                        :message="`Confirma a integração da disciplina <b>${disc.IDTURMADISC} - ${disc.CODDISC} - ${disc.DISCIPLINA}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{disc.IDTURMADISC}} - {{disc.CODDISC}} - {{disc.DISCIPLINA}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                    <!-- COORDENADORES GERENCIAIS -->
                    <v-row
                        v-show="StateCoordenadoresG.length && !!selectedTurmaG">
                        <div>
                            <h4>Coordenadores  ({{StateCoordenadoresG.length}})</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="coord in StateCoordenadoresG" :key="coord.CODUSUARIO" >
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            usuario: coord.CODUSUARIO,
                                            codturma: selectedTurmaG.CODTURMA,
                                        })"
                                        title="Integrar usuário na plataforma UNDB Classroom"
                                        header="Integração de usuário"
                                        :message="`Confirma a integração do usuário <b>${coord.CODUSUARIO} ${coord.NOME}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <confirm-gdb @confirm="onConfirmResetPassword($event, coord.CODUSUARIO)" title="Redefinição de senha UNDB Classroom"
                                        header="Redefinição de senha"
                                        :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário ${coord.CODUSUARIO} ${coord.NOME} na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small" :loading="StateResetPasswordMoodleUNDBLoading"
                                                color="warning">
                                                <v-icon small>mdi-lock-reset</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{coord.CODUSUARIO}} - {{coord.NOME}} - {{coord.EMAIL}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                    <!-- PROFESSORES GERENCIAIS -->
                    <v-row v-show="StateProfessoresG.length && !!selectedTurmaG">
                        <div>
                            <h4>Professores  ({{StateProfessoresG.length}})</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="prof in StateProfessoresG" :key="prof.CODUSUARIO">
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            usuario: prof.CODUSUARIO,
                                            codturma: selectedTurmaG.CODTURMA,
                                        })"
                                        title="Integrar usuário na plataforma UNDB Classroom"
                                        header="Integração de usuário"
                                        :message="`Confirma a integração do usuário <b>${prof.CODUSUARIO} ${prof.NOME}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <confirm-gdb @confirm="onConfirmResetPassword($event, prof.CODUSUARIO)" title="Redefinição de senha UNDB Classroom"
                                        header="Redefinição de senha"
                                        :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário ${prof.CODUSUARIO} ${prof.NOME} na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small" color="warning">
                                                <v-icon>mdi-lock-reset</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{prof.CODUSUARIO}} - {{prof.NOME}} - {{prof.EMAIL}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                    <!-- ALUNOS GERENCIAIS -->
                    <v-row v-show="StateAlunosG.length && !!selectedTurmaG">
                        <div>
                            <h4>Alunos ({{StateAlunosG.length}})</h4>
                            <v-divider class="my-1"></v-divider>
                            <div v-for="alu in StateAlunosG" :key="alu.RA">
                                <v-row class="py-1" style="align-items:center">
                                    <confirm-gdb @confirm="integrar($event, {
                                            usuario: alu.RA,
                                            codturma: selectedTurmaG.CODTURMA,
                                        })"
                                        v-if="!!selectedTurmaG"
                                        title="Integrar usuário na plataforma UNDB Classroom"
                                        header="Integração de usuário"
                                        :message="`Confirma a integração do usuário <b>${alu.RA} ${alu.ALUNO}</b> na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small"
                                                :loading="StateIntegraLoading">
                                                <v-icon>mdi-cloud-upload</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <confirm-gdb @confirm="onConfirmResetPassword($event, alu.RA)" title="Redefinição de senha UNDB Classroom"
                                        header="Redefinição de senha"
                                        :message="`Confirma a redefinição de nova senha <b>undb@class</b> para usuário ${alu.RA} ${alu.ALUNO} na plataforma UNDB Classroom?`">
                                        <template v-slot:buttonaction>
                                            <v-btn icon size="x-small" color="warning">
                                                <v-icon>mdi-lock-reset</v-icon>
                                            </v-btn>
                                        </template>
                                    </confirm-gdb>
                                    <span class="ml-1 pt-1">
                                        {{alu.RA}} - {{alu.ALUNO}}
                                    </span>
                                </v-row>
                            </div>
                        </div>
                    </v-row>
                </div>
                <!-- GERENCIADAS -->
                <div v-show="tab === 'gerenciadas'">
                    <v-row v-show="!selectedPerlet">
                        <v-spacer></v-spacer>
                        Selecione um período letivo
                        <v-spacer></v-spacer>
                    </v-row>
                    <!-- FILTRAR/CARREGAR GERENCIADAS -->
                    <v-row v-show="!!selectedPerlet">
                        <v-col cols="12" sm="12">
                            <v-row>
                                <v-text-field
                                    v-model="search_gerenciadas"
                                    label="Pesquisar...">
                                </v-text-field>
                                <v-spacer></v-spacer>
                                <v-btn :disabled="StateGerenciadasGLoading"
                                    @click.prevent="GetGerenciadasG({
                                        codperlet: selectedPerlet.CODPERLET,
                                    })">Carregar Gerenciadas</v-btn>
                            </v-row>
                            <v-data-table
                                multi-sort
                                :headers="headers_gerenciadas"
                                :items="StateGerenciadasG"
                                :items-per-page="10"
                                :sort-by="['CODGERENCIAL']"
                                :sort-desc="[false]"
                                :loading="StateGerenciadasGLoading"
                                loading-text="carregando..."
                                locale="pt-br"
                                :search="search_gerenciadas"
                                no-data-text='Nenhum registro'
                                no-results-text='Nenhum registro encontrado'
                                class="mx-0 transparent">
                            </v-data-table>
                        </v-col>
                    </v-row>
                </div>
            </v-card-text>
        </v-card>
    </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex';
export default {
    data:()=>({
        parametros:{
            codtipocurso: 2,
            codperlet:'2024.1'
        },
        search_gerenciadas:null,
        headers_gerenciadas: [
            { title: 'ID Geren', align: 'start', sortable: true, value: 'CODGERENCIAL', width:'50'},
            { title: 'Turma Geren', align: 'start', sortable: true, value: 'CODTURMAGERENCIAL', width:'170'},
            { title: 'Turma Normal', align: 'start', sortable: true, value: 'CODTURMANORMAL', width:'50'},
            { title: 'ID Normal', align: 'start', sortable: true, value: 'CODNORMAL', width:'50'},
            { title: 'Cód disc', align: 'start', sortable: true, value: 'CODDISC', width:'120'},
            { title: 'Disciplina', align: 'start', sortable: true, value: 'DISCIPLINA'},
        ],
        tab: null,
        selectedPerlet:null,
        // Normais
        selectedCurso:null,
        selectedTurma:null,
        selectedDisciplina:null,
        // Gerenciais
        selectedTurmaG:null,
        selectedDisciplinaG:null,
    }),
    mounted(){
        // this.GetPerlets({codperlet:'2022.1', codtipocurso:'2'})
        let data_atual = new Date()
        let ano_atual = data_atual.getFullYear()
        let perlet_atual = (data_atual.getMonth()+1) < 7 ? 1 : 2 ;
        this.parametros.codperlet = `${ano_atual}.${perlet_atual}`
        this.searchPerlets()
    },
    methods:{
        ...mapActions(['GetPerlets','GetCursos', 'GetTurmas', 'GetDisciplinas', 'GetAlunos', 'GetProfessores', 'GetCoordenadores',
                        'GetTurmasG', 'GetDisciplinasG', 'GetAlunosG', 'GetProfessoresG', 'GetCoordenadoresG', 'GetGerenciadasG',
                        'ResetPasswordMoodleUNDB', 'IntegraMoodleUNDB']),
        async searchPerlets(){
            this.selectedPerlet = null
            this.selectedCurso = null
            this.selectedTurma = null
            this.selectedDisciplina = null
            this.selectedTurmaG = null
            this.selectedDisciplinaG = null
            await this.GetPerlets({...this.parametros})
            if((this.StatePerlets || []).length == 1 ){
                this.selectedPerlet = this.StatePerlets[0]
            }
        },
        integrar(confirm, params){
            //21235
            if(confirm){
                this.IntegraMoodleUNDB({...params})
            }
        },
        onConfirmResetPassword(confirm, username){
            if(confirm){
                this.ResetPasswordMoodleUNDB({username})
            }
        }
    },
    computed:{
        ...mapGetters(['StateDark', 'StatePerlets', 'StateCursos','StateTurmas', 'StateDisciplinas', 'StateAlunos', 'StateProfessores', 'StateCoordenadores',
                    'StatePerletsLoading', 'StateCursosLoading', 'StateTurmasLoading', 'StateDisciplinasLoading', 'StateAlunosLoading','StateProfessoresLoading', 'StateCoordenadoresLoading', 'StateResetPasswordMoodleUNDBLoading',
                    'StateTurmasG', 'StateDisciplinasG', 'StateAlunosG', 'StateProfessoresG', 'StateCoordenadoresG', 'StateGerenciadasG',
                    'StateTurmasGLoading', 'StateDisciplinasGLoading', 'StateAlunosGLoading','StateProfessoresGLoading', 'StateCoordenadoresGLoading', 'StateIntegraLoading','StateGerenciadasGLoading'
                    ])
    },
    watch:{
        selectedPerlet:{
            handler(value){
                // console.log('handler selectedPerlet watch', value)
                if (value){
                    this.selectedCurso = null
                    this.GetCursos(
                        {
                            codtipocurso:this.selectedPerlet.CODTIPOCURSO,
                            codperlet:this.selectedPerlet.CODPERLET
                        })
                    this.GetTurmasG(
                        {
                            codperlet:this.selectedPerlet.CODPERLET
                        })
                }
            }
        },
        selectedCurso:{
            handler(value){
                if (value){
                    this.selectedTurma = null
                    this.selectedDisciplina = null
                    this.GetTurmas({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codtipocurso: this.selectedPerlet.CODTIPOCURSO,
                        codcurso: this.selectedCurso.CODCURSO
                    })
                    this.GetCoordenadores({
                        codtipocurso: this.selectedPerlet.CODTIPOCURSO,
                        codcurso: this.selectedCurso.CODCURSO
                    })
                }
            }
        },
        selectedTurma:{
            handler(value){
                this.selectedDisciplina = null
                if (value){
                    this.GetDisciplinas({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codtipocurso: this.selectedPerlet.CODTIPOCURSO,
                        codcurso: this.selectedCurso.CODCURSO,
                        codturma: this.selectedTurma.CODTURMA
                    })
                }
            }
        },
        selectedTurmaG:{
            handler(value){
                this.selectedDisciplinaG = null
                if (value){
                    this.GetDisciplinasG({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codturma: this.selectedTurmaG.CODTURMA
                    })
                    this.GetAlunosG({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codturma: this.selectedTurmaG.CODTURMA,
                    })
                    this.GetProfessoresG({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codturma: this.selectedTurmaG.CODTURMA,
                    })
                    this.GetCoordenadoresG({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codturma: this.selectedTurmaG.CODTURMA,
                    })
                }
            }
        },
        selectedDisciplina:{
            handler(value){
                if (value){
                    this.GetAlunos({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codtipocurso: this.selectedPerlet.CODTIPOCURSO,
                        codcurso: this.selectedCurso.CODCURSO,
                        codturma: this.selectedTurma.CODTURMA,
                        coddisc: this.selectedDisciplina.CODDISC
                    })
                    this.GetProfessores({
                        codperlet: this.selectedPerlet.CODPERLET,
                        codturma: this.selectedTurma.CODTURMA,
                        coddisc: this.selectedDisciplina.CODDISC
                    })
                }
            }
        },
    }
}
</script>